import React from 'react';

type SkeletonProps = React.HTMLAttributes<HTMLDivElement>;

export function Skeleton({ className = '', ...rest }: SkeletonProps) {
  return (
    <div
      className={`bg-gray-200/80 rounded-lg animate-pulse ${className}`}
      {...rest}
    />
  );
}
